/**
 * @author Adam Vlasek <adam.vlasek@styrax.cz>
 */

import React, { useEffect, useRef } from 'react';

import LoadableInterface from '../../types/LoadableInterface';

type LoadingContainerProps = LoadableInterface & {
    children?: JSX.Element | any
}

/**
 * Nacitaci obalka, v dobe nacitani zobrazuje misto obsahu loader.
 * @param children Funkce () => JSX.Element nebo JSX.Element s obsahem po nacteni.
 * @param loading Boolean priznak, jestli probiha nacitani.
 * @param called Boolean priznak, jestli uz bylo zavolano nacitani. Pokud jeste nebylo, tak se nezobrazuje obsah.
 * @param error Chybova hlaska, pokud se vyskytne chyba, tak se nezobrazuje obsah.
 * @example <LoadingContainer loading={} called={} error={}>children</LoadingContainer>
 * @returns React komponenta
 */
const LoadingContainer = ({ children = null, loading, error, called }: LoadingContainerProps): JSX.Element | null => {
    const errorRef = useRef<any>(null);

    //pokud se vyskytne error, tak se k němu automaticky odscrolluje
    useEffect(
        () => {
            if (!error || !errorRef?.current) return;

            errorRef.current.scrollIntoView();
        },
        [error, errorRef]
    );

    if (called === false) return (null);
    if (error) {
        return (
            <div
                style={{ color: 'red' }}
                ref={errorRef}>
                <span dangerouslySetInnerHTML={{ __html: error.message }} />
            </div>
        );
    }

    if (loading) return <div>načítám...</div>;

    return typeof children === 'function' ?
        children() :
        children;
};

export default LoadingContainer;
